import './api'
import './middleware'
import './resource'
import './transformer'



// WEBPACK FOOTER //
// ./src/js/resource/index.js